import { useCallback } from "react";
import { toast } from "@/components/podkit/toasts/use-toast";
import { formatError } from "@/utils/errors";
import { downloadAndSaveSupportBundle } from "@/utils/support-bundle";
import { useCreateEnvironmentLogsToken, type PlainEnvironment } from "@/queries/environment-queries";

export const useEnvironmentSupportBundle = (environment: PlainEnvironment) => {
    const { data: logsToken } = useCreateEnvironmentLogsToken(environment.id);
    const supportBundleUrl = environment.status?.environmentUrls?.supportBundle;
    const isSupportBundleAvailable = !!supportBundleUrl && !!logsToken;

    const downloadSupportBundle = useCallback(async () => {
        if (!supportBundleUrl || !logsToken) {
            return;
        }
        const generatingToast = toast({ title: "Generating support bundle...", indefinite: true });
        try {
            await downloadAndSaveSupportBundle({
                supportBundleUrl,
                logsToken,
                filename: `environment-support-bundle-${environment.id}.zip`,
            });
            generatingToast.dismiss();
            toast({ title: "Support bundle downloaded" });
        } catch (error) {
            generatingToast.dismiss();
            toast({
                title: "Failed to download support bundle",
                description: formatError(error),
            });
        }
    }, [supportBundleUrl, logsToken, environment.id]);

    return {
        downloadSupportBundle,
        isSupportBundleAvailable,
    };
};
